import { createSlice } from '@reduxjs/toolkit'
import { fetchFleetManagementVehicles } from './thunks'
import type { FleetManagementFetchProps, FleetVehicleData } from '../../components/FleetManagement/types'

export type FleetManagementSlice = {
	loading: boolean
	data: FleetManagementFetchProps | null
	isFetching: boolean
	vehicles: FleetVehicleData[]
	isError: boolean
	step: number
	numAdded: number
}
const initialState: FleetManagementSlice = {
	loading: false,
	data: null,
	vehicles: [],
	isFetching: false,
	isError: false,
	numAdded: 0,
	step: 1,
}

export const fleetManagementSlice = createSlice({
	name: 'fleetManagement',
	initialState,
	reducers: {
		resetFleetManagement() {
			return initialState
		},
		setStep(state, action) {
			state.step = action.payload
		},
	},
	extraReducers: builder => {
		builder.addCase(fetchFleetManagementVehicles.rejected, state => {
			state.loading = false
			state.isError = true
		}),
			builder.addCase(fetchFleetManagementVehicles.pending, state => {
				state.loading = true
				state.isError = false
				state.isFetching = true
			}),
			builder.addCase(fetchFleetManagementVehicles.fulfilled, (state, action) => {
				if (action.payload) {
					state.data = action.payload
					state.loading = false
					state.isFetching = false
					state.isError = false
					if (action.payload.data) {
						state.vehicles = action.payload?.data ? state.vehicles.concat(action.payload.data) : null
						state.numAdded = action.payload.data?.length ? action.payload.data.length : 0
					}
				}
			})
	},
})
export const selectFleetManagement = state => state.fleetManagementSlice
export const selectFmVehicles = state => state.fleetManagement.vehicles
export const { resetFleetManagement, setStep } = fleetManagementSlice.actions
export const fleetManagementSliceReducer = fleetManagementSlice.reducer
